/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export default import.meta.env.DEV ? (await import("@hookform/devtools")).DevTool : () => null;
